import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import CustomizePage from 'modules/videos/components/create/CustomizePage';
import React, { useState } from 'react';
import { getVideoPages, saveVideoPage } from 'services/videoPages.service';
import { snack } from 'utils/toast';
import { ModalContent, ModalActions } from 'components/Modal/Modal';

const NewPageModal = ({ onCancel, onPageSaved }) => {
  const [values, setValues] = useState({});

  const handleChange = (name, val) => {
    setValues((prev) => ({ ...prev, [name]: val }));
  };

  const onSave = async () => {
    const resp = await saveVideoPage({
      ...values,
    });
    const [page] = await getVideoPages({ hash: resp.hash });
    snack.success('Page saved.');
    onPageSaved(page.redirect.qr_code_text);
    onCancel();
  };

  return (
    <>
      <ModalContent>
        <Typography color="text.secondary">
          Ideal for quickly drafting short, unbranded page. If you want to style
          your page or increase the number of characters, create it from the
          Pages page instead.{' '}
          <MuiLink target="_blank" href="/pages/create">
            Yes, take me there!
          </MuiLink>
        </Typography>
        <Box>
          <CustomizePage
            hideVideoOptions
            values={values}
            onChange={handleChange}
          />
        </Box>
      </ModalContent>
      <ModalActions>
        <Button
          disabled={
            !values.headline ||
            !values.message ||
            (values.call_to_action_enabled === '1' &&
              (!values.call_to_action_text || !values.call_to_action))
          }
          onClick={onSave}
        >
          Publish
        </Button>
      </ModalActions>
    </>
  );
};

export default NewPageModal;
